<template>
  <div v-if="featured.length > 0" :class="{'tw-col-span-full': !page.featured.primary.show}">
    <div class="tw-grid tw-gap-2 sm:tw-gap-4 tw-grid-cols-2"
         :class="{'sm:tw-grid-cols-4' : !page.featured.primary.show }">
      <PrimaryBeatCard v-for="beat in featured" :key="beat.id" :beat="beat" :image-size="300" />
    </div>
  </div>

  <div v-else class="tw-text-center">
    <loading-icon></loading-icon>
  </div>
</template>

<script>
import BeatContainer from "./../beatcontainer.vue";
import LoadingIcon from "./../loadingicon.vue";
import Beat from "./../../models/beat";
import Playlist from "./../../classes/playlist";
import PrimaryBeatCard from "../next/PrimaryBeatCard";
import PrimaryBeatCardGrid from "../next/PrimaryBeatCardGrid";

export default {
  props: ["pageId"],
  components: {
    PrimaryBeatCardGrid,
    PrimaryBeatCard,
    BeatContainer,
    LoadingIcon
  },
  data() {
    return {
      music: []
    };
  },
  computed: {
    page() {
      if (this.pageId) {
        return this.config.getPageById(this.pageId);
      }
      return false;
    },
    config() {
      return this.$store.state.currentConfig;
    },
    user() {
      return this.$store.state.user;
    },
    playlistManager() {
      return this.$store.state.playlistManager;
    },
    pagePlaylist() {
      return this.playlistManager.getPagePlaylist();
    },
    featured() {
      return this.$store.state.discoverPlaylist.secondary;
    }
  }
};
</script>
